module.exports = __webpack_public_path__ + "8e05a4a94e699c7a4d2ad0a0a38f9ac9.jpg";